/* global I18n, ValidationPipeline, Validation,
 ValidationGroup, ThemeSettings, _hashed_password */

 if (headerData('has-customer')) {
  const custTags = document.querySelector('.customer-tags-list').getAttribute('data-customer-tags')?.trim();
  const tagArray = custTags.split(' ');
  
  tagArray.forEach((tags) => {
    const resetToken = tags.split('_');
    const accessToken = getCookie('_uat');
    if (resetToken[1] !== '' && accessToken !== '') {
      const checkToken = resetToken[1]?.toUpperCase() === accessToken?.toUpperCase();
      if (checkToken) {
        const desktopLogout = document.querySelector('.menu-logout');
        if (desktopLogout) desktopLogout.click();
        
        const mobileLogout = document.querySelector('.mobile-menu-logout');
        if (mobileLogout) mobileLogout.click();
      }
    }
  });
}
